import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core';
import { FtoReportSummaryTechFeaturesService } from '../summary-tech-features-service';
import { FtoReportRetrievalResultReportModel } from '../../models/retrieval-result-report-model';
import { FtoReportInputSummaryApi } from '../../apis/novelty-input-summary-api';

@injectable()
export class FtoReportSummaryTechFeaturesServiceImpl implements FtoReportSummaryTechFeaturesService {
    constructor(
        @inject(FtoReportInputSummaryApi)
        private readonly _noveltyInputSummaryApi: FtoReportInputSummaryApi,
        @inject(FtoReportRetrievalResultReportModel)
        private readonly _retrievalResultReportModel: FtoReportRetrievalResultReportModel,
    ) { }

    private _onSummaryLoadingEmitter = new Emitter<boolean>();

    get onSummaryLoading() {
        return this._onSummaryLoadingEmitter.event;
    }

    async pullSummary(taskId: string): Promise<string> {
        const text = await this._summaryRepository(taskId);
        if (text) {
            this._retrievalResultReportModel.update((state) => {
                state.techEssential = text;
                return state;
            });
        }
        return text;
    }

    private async _summaryRepository(taskId: string) {
        this._onSummaryLoadingEmitter.fire(true);
        try {
            const text = this._retrievalResultReportModel.modelData.techEssential;
            const res = await this._noveltyInputSummaryApi.summarizeNoveltyInput({ task_id: taskId, text });
            return res;
        } finally {
            this._onSummaryLoadingEmitter.fire(false);
        }
    }
}
